<div mat-dialog-title role="heading" aria-level="1">
	Add Activity
</div>
<mat-dialog-content>
	<activity-type-menu
		(subTypeClick)="startNewActivity($event)"
		[activityTypes]="activityTypes"
		[activityCategories]="activityCategories"
		[startingActivityCategoryId]="startingActivityCategoryId"></activity-type-menu>
</mat-dialog-content>